import React from 'react';
import { connect } from 'react-redux';
import { Field } from 'redux-form';
import renderTextField from '../../components/MaterialUi/renderTextField';
import RFSelectField from '../../components/ReduxFormComps/RFSelectField';
import RFCheckboxField from '../../components/ReduxFormComps/RFCheckboxField';
import RFDatePickerField from '../../components/ReduxFormComps/RFDatePickerField';
import Paper from '@material-ui/core/Paper'
import ContentRowSpace from './common/ContentRowSpace'
import styles from './common/styles';

class DocFormMemberEmployee extends React.Component {

    shouldComponentUpdate(nextProps, nextState) {
        if (this.props.isOverrideMemEmpCheckWhoIsApply !== nextProps.isOverrideMemEmpCheckWhoIsApply) {
            return true;
        }
        if (this.props.isOverrideMemEmpFirstNameNotFound !== nextProps.isOverrideMemEmpFirstNameNotFound) {
            return true;
        }
        if (this.props.isOverrideMemEmpLastNameNotFound !== nextProps.isOverrideMemEmpLastNameNotFound) {
            return true;
        }
        return false;
    }

    render(){
        const { gorgon,isOverrideMemEmpCheckWhoIsApply,isOverrideMemEmpFirstNameNotFound,isOverrideMemEmpLastNameNotFound } = this.props;
        
       return (
           <div>
               <Paper>
                    <div className="container">
                        <ContentRowSpace /> 
                        <div className="row">
                            <div className='col-sm'>
                                <Field
                                    name="memEmpNameOfGroup"
                                    component={renderTextField}
                                    label="Name of Group"
                                    style={styles.nameTextFieldStyle}
                                />
                            </div>
                            <div className='col-sm'>
                                <Field
                                    name="memEmpNameOfAgency"
                                    component={renderTextField}
                                    label="Name of Agency Institution"
                                    style={styles.nameTextFieldStyle}
                                />
                            </div>
                        </div> 
                        <div className="row">
                            <div className='col-sm'>
                                <Field
                                    name="memEmpGroupNumber"
                                    component={renderTextField}
                                    label="Group Number"
                                    style={styles.nameTextFieldStyle}
                                />
                            </div>
                            <div className='col-sm'>
                                {!isOverrideMemEmpCheckWhoIsApply?(
                                <Field
                                    label="*Check Who is Applying"
                                    name="memEmpCheckWhoIsApply"
                                    datas={gorgon.memEmpTypes}
                                    component={RFSelectField}
                                    codeField={'code'}
                                    descField={'desc'}
                                    customStyle={styles.nameTextFieldStyle}
                                />    
                                ):null}
                                <Field name="isOverrideMemEmpCheckWhoIsApply" 
                                component={RFCheckboxField} 
                                label="Type of applicant is not specified in the document" />
                            </div>    
                        </div>  
                        <div className="row">
                            <div className='col-sm'>
                            {!isOverrideMemEmpFirstNameNotFound?(
                                <Field
                                    name="memEmpFirstName"
                                    component={renderTextField}
                                    label="*First Name"
                                    style={styles.nameTextFieldStyle}
                                />
                            ):null}
                                <Field name="isOverrideMemEmpFirstNameNotFound" 
                                component={RFCheckboxField} 
                                label="First Name Not Found in Document" />
                            </div>
                            <div className='col-sm'>
                                <Field
                                    name="memEmpMiddleName"
                                    component={renderTextField}
                                    label="Middle Name"
                                    style={styles.nameTextFieldStyle}
                                />
                            </div>
                        </div>     
                        <div className="row">
                            <div className='col-sm'>
                                {!isOverrideMemEmpLastNameNotFound?(
                                <Field
                                    name="memEmpLastName"
                                    component={renderTextField}
                                    label="*Last Name"
                                    style={styles.nameTextFieldStyle}
                                />
                                ):null}
                                <Field name="isOverrideMemEmpLastNameNotFound" 
                                component={RFCheckboxField} 
                                label="Last Name Not Found in Document" />
                            </div>
                            <div className='col-sm'>
                                <Field
                                    name="memEmpNameSuffix"
                                    component={renderTextField}
                                    label="Name Suffix"
                                    style={styles.nameTextFieldStyle}
                                />
                            </div>
                        </div> 
                        <div className="row">
                            <div className='col-sm'>
                                <Field
                                    name="memEmpBirthdate"
                                    component={RFDatePickerField}
                                    label="Birthdate"
                                    inputDateFormat='MM/DD/YYYY'
                                    style={styles.nameTextFieldStyle}
                                    inputNote="US date format MM/DD/YYYY"
                                />
                            </div>
                            <div className='col-sm'>
                                <Field
                                    name="memEmpDatehired"
                                    component={RFDatePickerField}
                                    label="Date Hired"
                                    inputDateFormat='MM/DD/YYYY'
                                    style={styles.nameTextFieldStyle}
                                    inputNote="US date format MM/DD/YYYY"
                                />
                            </div>
                        </div>   
                        <div className="row">
                            <div className='col-sm'>
                                <Field
                                    name="memEmpOccupation"
                                    component={renderTextField}
                                    label="Occupation"
                                    style={styles.nameTextFieldStyle}
                                />
                            </div>
                            <div className='col-sm'>
                                <Field
                                    name="memEmpSalary"
                                    component={renderTextField}
                                    label="Salary"
                                    style={styles.nameTextFieldStyle}
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className='col-sm'>
                                <Field
                                    name="memEmpSSN"
                                    component={renderTextField}
                                    label="Social Security Number"
                                    style={styles.nameTextFieldStyle}
                                />
                            </div>
                            <div className='col-sm'>
                                <Field
                                    name="memEmpIdentificationNum"
                                    component={renderTextField}
                                    label="Member/Employee Identification No."
                                    style={styles.nameTextFieldStyle}
                                />
                            </div>
                        </div>   
                        <ContentRowSpace />              
                    </div>
                </Paper>
           </div>  
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        gorgon: state.gorgon
    }
}

export default connect(mapStateToProps)(DocFormMemberEmployee);


// WEBPACK FOOTER //
// ./src/views/ProjectGorgon/DocFormMemberEmployee.js